module.exports = __webpack_public_path__ + "img/2.da2ff87e.png";